import React from "react";
import { MapPin, Users, Store, Building, Truck } from "lucide-react";

const Pds = () => {
  const stats = [
  {
    icon: <Store className="w-10 h-10 text-blue-500" />,
    title: "35,377",
    subtitle: "Cooperative-run Fair Price Shops",
  },
  {
    icon: <Users className="w-10 h-10 text-blue-500" />,
    title: "216.07 lakh",
    subtitle: "Family Card Holders",
  },
  {
    icon: <Building className="w-10 h-10 text-blue-500" />,
    title: "6",
    subtitle: "Cooperative institution types involved",
  },
  {
    icon: <MapPin className="w-10 h-10 text-blue-500" />,
    title: "100%",
    subtitle: "Digital PDS with Smart Cards",
  },
  {
    icon: <Truck className="w-10 h-10 text-blue-500" />,
    title: "2,433",
    subtitle: "Mobile Fair Price Shops",
  },
];

  return (
<div className="min-h-screen bg-slate-50 font-sans">
      {/* Header */}
      <header className="text-center py-12 bg-white shadow-sm w-full">
        <h1 className="text-4xl font-bold text-gray-800">
          Public Distribution System
        </h1>
      </header>

  {/* Overview Section */}
      <section className="w-full px-6 sm:px-10 lg:px-20 py-12 bg-blue-50">
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Overview</h2>
        <div className="border-l-4 border-blue-500 pl-6 bg-blue py-4 pr-4">
          <p className="text-gray-700 leading-relaxed text-lg">
          The Public Distribution System (PDS) in Tamil Nadu functions through Fair Price Shops (FPS) managed by the coordinated efforts of Civil Supplies and Consumer Protection Department, Registrar of Cooperative Societies and Tamil Nadu Civil Supplies Corporation (TNCSC) ensuring reliable and universal access to essential commodities for all the family card holders.
Under the oversight of the Registrar of Cooperative Societies, cooperatives run the majority of Fair Price Shops across the state, enabling the delivery of Essential Commodities such as Rice, Sugar, Wheat, Kerosene and Special Commodities such as Toor Dall and Palm Oil. 
With end-to-end digital systems, smart cards, and e-POS devices, the cooperative-led PDS ensures transparency, timely supply, and efficient service delivery, forming one of the most extensive and people-centric distribution networks in the country.
          </p>
        </div>
      </section>

{/* How PDS Works – Updated UI */}
<section className="w-full px-6 sm:px-10 lg:px-20 py-16 bg-white -pt-10">
  <h2 className="text-center font-bold text-3xl text-gray-900">
    How PDS Works
  </h2>

  <div className="flex flex-col lg:flex-row items-center justify-between gap-10">

    {/* Step 1 */}
    <div className="flex flex-col items-center text-center max-w-[260px]">
      <div className="w-16 h-16 rounded-full bg-[#005598] text-white flex items-center justify-center text-2xl font-bold">
        1
      </div>
      <h3 className="text-xl font-semibold mt-4">Procurement</h3>
      <p className="text-gray-600 mt-2">
        Essential commodities are sourced through cooperatives & government agencies.
      </p>
    </div>

    {/* Arrow */}
    <div className="hidden lg:block text-gray-500 text-4xl font-light">
      →
    </div>

    {/* Step 2 */}
    <div className="flex flex-col items-center text-center max-w-[260px]">
      <div className="w-16 h-16 rounded-full bg-[#005598] text-white flex items-center justify-center text-2xl font-bold">
        2
      </div>
      <h3 className="text-xl font-semibold mt-4">Allocation & Storage</h3>
      <p className="text-gray-600 mt-2">
        Stocks move to district godowns & cooperative wholesale points.
      </p>
    </div>

    {/* Arrow */}
    <div className="hidden lg:block text-gray-500 text-4xl font-light">
      →
    </div>

    {/* Step 3 */}
    <div className="flex flex-col items-center text-center max-w-[260px]">
      <div className="w-16 h-16 rounded-full bg-[#005598] text-white flex items-center justify-center text-2xl font-bold">
        3
      </div>
      <h3 className="text-xl font-semibold mt-4">Distribution</h3>
      <p className="text-gray-600 mt-2">
        33,000+ cooperative Fair Price Shops supply essentials to families.
      </p>
    </div>

    {/* Arrow */}
    <div className="hidden lg:block text-gray-500 text-4xl font-light">
      →
    </div>

    {/* Step 4 */}
    <div className="flex flex-col items-center text-center max-w-[260px]">
      <div className="w-16 h-16 rounded-full bg-[#005598] text-white flex items-center justify-center text-2xl font-bold">
        4
      </div>
      <h3 className="text-xl font-semibold mt-4">Monitoring</h3>
      <p className="text-gray-600 mt-2">
        Smart cards, e-POS devices & digital systems ensure transparency.
      </p>
    </div>

  </div>
</section>
{/* Key Stats – Single Line Auto Scroll */}
<section className="w-full py-10 overflow-hidden">
  <h2 className="text-3xl font-semibold mb-8 px-6 text-gray-800">
    Key Stats
  </h2>

  <div className="w-full bg-[#7EC3FF] py-6 overflow-hidden">
    <div className="flex gap-6 whitespace-nowrap animate-scroll w-max">

      {[...stats, ...stats].map((item, i) => (
        <div
          key={i}
          className="bg-white min-w-[300px] h-[120px] rounded-lg shadow-sm px-6 flex items-center gap-5 flex-shrink-0"
        >
          <div className="bg-blue-50 p-4 rounded-full flex items-center justify-center">
            {item.icon}
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-800 leading-tight">
              {item.title}
            </h3>
            <p className="text-gray-600 text-base leading-snug">
              {item.subtitle}
            </p>
          </div>
        </div>
      ))}

    </div>
  </div>
</section>


      {/* Metrics & Image Section */}
      <section className="w-full px-6 sm:px-10 lg:px-20 py-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
    <div className="bg-white rounded-lg shadow-md p-6 border">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800">Metrics</h2>
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Store Metrics</span>
              <select className="border rounded px-2 py-1 text-sm">
                <option>Today</option>
              </select>
            </div>
          </div>
          <div className="h-72 relative">
            <svg className="w-full h-full" viewBox="0 0 600 300">
              {/* Grid lines */}
              <line x1="50" y1="40" x2="550" y2="40" stroke="#e5e7eb" strokeWidth="1"/>
              <line x1="50" y1="90" x2="550" y2="90" stroke="#e5e7eb" strokeWidth="1"/>
              <line x1="50" y1="140" x2="550" y2="140" stroke="#e5e7eb" strokeWidth="1"/>
              <line x1="50" y1="190" x2="550" y2="190" stroke="#e5e7eb" strokeWidth="1"/>
              <line x1="50" y1="240" x2="550" y2="240" stroke="#e5e7eb" strokeWidth="1"/>
              
              {/* Y-axis labels */}
              <text x="30" y="45" fontSize="12" fill="#6b7280">1000</text>
              <text x="35" y="95" fontSize="12" fill="#6b7280">750</text>
              <text x="35" y="145" fontSize="12" fill="#6b7280">500</text>
              <text x="35" y="195" fontSize="12" fill="#6b7280">250</text>
              <text x="45" y="245" fontSize="12" fill="#6b7280">0</text>
              
              {/* X-axis labels */}
              <text x="70" y="270" fontSize="12" fill="#6b7280">0</text>
              <text x="130" y="270" fontSize="12" fill="#6b7280">1</text>
              <text x="190" y="270" fontSize="12" fill="#6b7280">2</text>
              <text x="250" y="270" fontSize="12" fill="#6b7280">3</text>
              <text x="310" y="270" fontSize="12" fill="#6b7280">4</text>
              <text x="370" y="270" fontSize="12" fill="#6b7280">5</text>
              <text x="430" y="270" fontSize="12" fill="#6b7280">6</text>
              <text x="490" y="270" fontSize="12" fill="#6b7280">7</text>
              <text x="540" y="270" fontSize="12" fill="#6b7280">8</text>
              
              {/* Line chart - points: (400,155), (200,190), (450,140), (980,55), (450,140), (500,190), (200,55), (520,190), (980,85), (650,165) */}
              <polyline
                points="75,155 135,200 195,130 255,55 315,140 375,200 435,55 495,130 545,85"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="2"
              />
              
              {/* Data points */}
              <circle cx="75" cy="155" r="4" fill="#3b82f6"/>
              <circle cx="135" cy="200" r="4" fill="#3b82f6"/>
              <circle cx="195" cy="130" r="4" fill="#3b82f6"/>
              <circle cx="255" cy="55" r="4" fill="#3b82f6"/>
              <circle cx="315" cy="140" r="4" fill="#3b82f6"/>
              <circle cx="375" cy="200" r="4" fill="#3b82f6"/>
              <circle cx="435" cy="55" r="4" fill="#3b82f6"/>
              <circle cx="495" cy="130" r="4" fill="#3b82f6"/>
              <circle cx="545" cy="85" r="4" fill="#3b82f6"/>
            </svg>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border">
          <img
            src="/Images/picss.jpg"
            alt="PDS Process"
            className="rounded-md w-full h-full object-cover"
          />
        </div>
      </section>

 {/* Store Locations */}
      <section className="w-full px-6 sm:px-10 lg:px-20 py-14">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          Store Locations
        </h2>
        <div className="bg-white rounded-lg shadow-md border overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-[60%_40%]">
            {/* Map Section */}
            <div className="h-[400px] lg:h-[500px] relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125384.30132503736!2d76.95318444999999!3d11.0168445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af2f971cb5%3A0x2fc1c81e183ed282!2sCoimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Fair Price Shop Locations"
              ></iframe>
            </div>

            {/* Filter Section */}
            <div className="bg-white p-6 border-l border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">District</h3>
              <select className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full text-base mb-6">
                <option>Select District</option>
                <option>Coimbatore</option>
                <option>Chennai</option>
                <option>Madurai</option>
                <option>Salem</option>
                <option>Tiruchirappalli</option>
                <option>Tirunelveli</option>
                <option>Erode</option>
                <option>Vellore</option>
              </select>

              <h3 className="text-lg font-semibold text-gray-800 mb-4">Select Block</h3>
              <select className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full text-base mb-6">
                <option>Select Block</option>
                <option>Primary Cooperative Society</option>
                <option>Urban Cooperative Society</option>
                <option>Rural Cooperative Society</option>
                <option>Consumer Cooperative</option>
              </select>

              <button className="bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors w-full text-base font-medium flex items-center justify-center gap-2">
                <MapPin className="w-4 h-4" />
                FILTER
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pds;